module.exports = __webpack_public_path__ + "media/soundtrack.c35240b6.mp3";